import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "status"]
  
  static values = {
    activeUrl: String,
    inactiveUrl: String,
    activeStatus: String,
    inactiveStatus: String,
    state: Boolean
  }

  connect() {
    this.updateState()
  }

  async toggle(event) {
    event.preventDefault()
    
    const url = this.stateValue ? this.inactiveUrlValue : this.activeUrlValue
    
    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        this.stateValue = !this.stateValue
        this.updateState()
      }
    } catch (error) {
      console.error('Toggle error:', error)
    }
  }

  updateState() {
    if (this.hasButtonTarget) {
      const button = this.buttonTarget
      const [icon, cssClass] = this.stateValue ? 
        ['<i class="fas fa-times"></i>', 'text-red-600 hover:text-red-900'] : 
        ['<i class="fas fa-thumbs-up"></i>', 'text-green-600 hover:text-green-900']
      
      button.innerHTML = icon
      button.className = cssClass
    }

    if (this.hasStatusTarget) {
      const status = this.statusTarget
      const [text, cssClass] = this.stateValue ? 
        [this.activeStatusValue, 'text-green-600'] : 
        [this.inactiveStatusValue, 'text-red-600']

      status.textContent = text
      status.className = cssClass
    }
  }
}
